import { render, staticRenderFns } from "./EbookingsCustomizationsTable.vue?vue&type=template&id=9b866f00&scoped=true"
import script from "./EbookingsCustomizationsTable.vue?vue&type=script&lang=js"
export * from "./EbookingsCustomizationsTable.vue?vue&type=script&lang=js"
import style0 from "./EbookingsCustomizationsTable.vue?vue&type=style&index=0&id=9b866f00&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b866f00",
  null
  
)

export default component.exports